module.exports = __webpack_public_path__ + "media/images/enable_camera-1cd00eb95ee4ad8fdc29f5fb4e3f1867c11217075035dc1af1fd8b707aa6541c.svg";